// extracted by mini-css-extract-plugin
export default {"contactBtn":"CustomContactBtn--contactBtn--V8wQ_"};